module.exports = __webpack_public_path__ + "img/edoge.170ec737.svg";